class WishlistIcon extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.bubble = this.querySelector('[data-wishlist-bubble]');
    this.countElement = this.querySelector('[data-wishlist-count]');
    this.countTextElement = this.querySelector('[data-wishlist-count-text]');

    // Wait for wishlist.js to load
    this.waitForWishlist();
  }

  waitForWishlist() {
    if (window.Wishlist) {
      this.init();
    } else {
      // Retry after a short delay
      setTimeout(() => this.waitForWishlist(), 100);
    }
  }

  init() {
    // Update count on load
    this.updateCount();

    // Listen for wishlist updates
    this.boundUpdateCount = () => this.updateCount();
    document.addEventListener('wishlist:updated', this.boundUpdateCount);
  }

  disconnectedCallback() {
    if (this.boundUpdateCount) {
      document.removeEventListener('wishlist:updated', this.boundUpdateCount);
    }
  }

  updateCount() {
    if (!window.Wishlist) return;

    const count = window.Wishlist.getCount();

    if (this.countElement) {
      this.countElement.textContent = count;
    }

    if (this.countTextElement) {
      this.countTextElement.textContent = count;
    }

    // Show/hide bubble
    if (this.bubble) {
      if (count > 0) {
        this.bubble.classList.remove('visually-hidden');
        if (this.countElement) {
          this.countElement.classList.remove('hidden');
        }
      } else {
        this.bubble.classList.add('visually-hidden');
        if (this.countElement) {
          this.countElement.classList.add('hidden');
        }
      }
    }

    // Update maintain-ratio attribute for single/double digit
    if (this.bubble) {
      if (count <= 99) {
        this.bubble.setAttribute('data-maintain-ratio', '');
      } else {
        this.bubble.removeAttribute('data-maintain-ratio');
      }
    }
  }
}

customElements.define('wishlist-icon', WishlistIcon);
